module.exports = __webpack_public_path__ + "static/media/23.fb5fd2fa.mp3";